import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid fill-height login--background" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background--overlay" }, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xl-4 col-lg-4 col-sm-12 col-md-6" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header justify--center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-content ma--top-1" }
const _hoisted_9 = { class: "form-field__control form-field__control--icon" }
const _hoisted_10 = ["type"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-field__label"
}, "New Password", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-field__control--icon__prefix" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-key" })
], -1)
const _hoisted_13 = { class: "form-field__control--icon__suffix" }
const _hoisted_14 = { class: "form-field__error--box" }
const _hoisted_15 = { class: "error--message" }
const _hoisted_16 = { class: "error--message" }
const _hoisted_17 = { class: "error--message" }
const _hoisted_18 = { class: "error--message" }
const _hoisted_19 = { class: "error--message" }
const _hoisted_20 = { class: "form-field__control form-field__control--icon" }
const _hoisted_21 = ["type"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-field__label"
}, "Confirm Password", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "form-field__control--icon__prefix" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-key" })
], -1)
const _hoisted_24 = { class: "form-field__control--icon__suffix" }
const _hoisted_25 = { class: "ma--y-1 text--align-center" }
const _hoisted_26 = {
  type: "submit",
  class: "btn btn--primary btn--large"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "loading-circle"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_33 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!
  const _directive_sameAs = _resolveDirective("sameAs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.logo,
              class: "login-logo",
              alt: "Lead Pulse"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard ma--y-2", {
                  'form-field--is-invalid': _ctx.v$.request.password.$error,
                  'form-field--is-active': !_ctx.v$.request.password.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showPassword ? 'text' : 'password',
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.password) = $event))
                  }, null, 8, _hoisted_10), [
                    [
                      _vModelDynamic,
                      _ctx.request.password,
                      void 0,
                      { trim: true }
                    ],
                    [_directive_focus]
                  ]),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", {
                        'fa-eye': _ctx.showPassword,
                        'fa-eye-slash': !_ctx.showPassword,
                      }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.minLength.$invalid)])
                    }, null, 2),
                    _createTextVNode(" Minimum 8 characters ")
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.number.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one number ")
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.special.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one special character ")
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.uppercase.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one Uppercase ")
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.lowercase.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one Lowercase ")
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard ma--y-2", {
                  'form-field--is-invalid': _ctx.v$.request.confirmPassword.$error,
                  'form-field--is-active': !_ctx.v$.request.confirmPassword.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showConfirmPassword ? 'text' : 'password',
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.confirmPassword) = $event))
                  }, null, 8, _hoisted_21), [
                    [
                      _vModelDynamic,
                      _ctx.request.confirmPassword,
                      void 0,
                      { trim: true }
                    ],
                    [_directive_focus],
                    [_directive_sameAs, _ctx.request]
                  ]),
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", {
                        'fa-eye': _ctx.showConfirmPassword,
                        'fa-eye-slash': !_ctx.showConfirmPassword,
                      }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showConfirmPassword = !_ctx.showConfirmPassword))
                    }, null, 2)
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", _hoisted_26, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Update"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_33))
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}